import { logsAuditoria, type LogAuditoria } from './auditoria';

let auditData = [...logsAuditoria];

export function registrarAuditoria(
  acao: string,
  modulo: LogAuditoria['modulo'],
  detalhes: string,
  usuario: string,
  usuarioRole: string,
  entidadeId?: string,
  entidadeTipo?: string
): LogAuditoria {
  const novoLog: LogAuditoria = {
    id: `LOG-${String(auditData.length + 1).padStart(3, '0')}`,
    acao,
    modulo,
    usuario,
    usuarioRole,
    detalhes,
    data: new Date().toISOString(),
    ip: '192.168.1.200',
    entidadeId,
    entidadeTipo,
  };
  auditData = [novoLog, ...auditData];
  return novoLog;
}

export function getLogsAuditoria(): LogAuditoria[] {
  return auditData;
}

export function getLogsPorEntidade(
  entidadeTipo: string,
  entidadeId: string
): LogAuditoria[] {
  return auditData.filter(
    (l) => l.entidadeTipo === entidadeTipo && l.entidadeId === entidadeId
  );
}